<button
  shrdUicButton
  variant="tertiaryMinorBorderlessNeutralDark"
  class="my-0 text-center meta-nav-item"
  [ngClass]="{ 'text-primary': userData.isLoggedIn && !userData.isRegistered }"
  shrdUicFlyout
  [ngbPopover]="flyoutRegisteredUser"
  placement="bottom"
  [autoPosFixedWidth]="!userData.accountMenuEnabled"
  [placeInStickyParent]="true"
  [showWhiteArrow]="true"
  (visibilityChange)="handleFlyoutVisibilityChange($event)"
>
  <span shrdPfUiMaxWidth [@labelSlide]="true" [@.disabled]="!animateLabel" class="no-truncate">
    <ng-container *ngIf="userData.isRegistered && !userData.isAccountSync; else pendingUserTemplate">
      <shrd-pf-ui-header-user-name [user]="userData.selectedAccount.contact"></shrd-pf-ui-header-user-name>
      <ng-container *ngIf="userData.selectedAccount?.originId as originId">({{ originId }})&#x200E;</ng-container>
    </ng-container>
    <ng-template #pendingUserTemplate>
      {{ (userData.isAccountSync ? 'header.account.accountSync' : 'header.account.registrationPending') | i18next }}
    </ng-template>
  </span>
  <shrd-uic-svg-icon icon="profile"></shrd-uic-svg-icon>
</button>

<ng-template #flyoutRegisteredUser>
  <div class="container-fluid" *ngIf="userData.accountMenuEnabled; else flyoutBody">
    <div class="row">
      <div class="col-24">
        <ng-container *ngTemplateOutlet="flyoutBody"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #flyoutBody>
  <shrd-uic-flyout-body
    class="p-0 d-none d-md-block"
    [ngClass]="{ 'flyout-fixed-width': !userData.accountMenuEnabled }"
    [scrollbarEnabled]="false"
    [hasGrid]="false"
    [autoUpdateFocusScope]="true"
  >
    <ng-container [ngTemplateOutlet]="contentRef"></ng-container>
  </shrd-uic-flyout-body>
</ng-template>
